import { createSelector } from 'reselect'

import { Nullable } from '@probatix/common/models/global'

import { Customer } from '@probatix/common/services/RTKServices/patients/index.model'

import { AuthRootState, AuthState } from './auth.model'

export const getAuthState = (state: AuthRootState): AuthState => state.auth

export const selectMainUser = createSelector(
  [getAuthState],
  (state): Nullable<Customer> => state.data,
)

export const selectUserEmail = createSelector(
  [getAuthState],
  (state): string => {
    try {
      if (!state.data!) {
        return ''
      }

      return state.data?.email!
    } catch (error) {
      return ''
    }
  },
)
